import { numFormat } from '@/helpers/numFormat';

export function unit(value: any, unit: string): string {
  return `${numFormat(Number(value))} ${unit}`;
}